module.exports = __webpack_public_path__ + "static/staff_of_frost-7c024881e24c618dac78a0a7090a7052.jpeg";